import {i18n} from "next-i18next";
import {DEFAULT_LANG} from "@pency/constants/catalogs/i18n";

export function getLocale() {
  return i18n.language !== DEFAULT_LANG ? i18n?.language : "";
}
